module.exports = __webpack_public_path__ + "static/media/job.43bc6292.svg";